var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitiative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.5 7 C 3.6 7 2 8.6 2 10.5 C 2 12.4 3.6 14 5.5 14 L 42.5 14 C 44.4 14 46 12.4 46 10.5 C 46 8.6 44.4 7 42.5 7 L 5.5 7 z M 5 16 L 5 38 L 4.5 38 A 1.50015 1.50015 0 1 0 4.5 41 L 22.5 41 L 22.5 43.679688 A 2 2 0 0 0 24 47 A 2 2 0 0 0 25.5 43.677734 L 25.5 41 L 43.5 41 A 1.50015 1.50015 0 1 0 43.5 38 L 43 38 L 43 16 L 5 16 z M 34 20 C 35.1 20 36 20.9 36 22 C 36 23.1 35.199609 23.9 34.099609 24 L 28 30.099609 C 27.9 31.099609 27.1 32 26 32 C 24.9 32 24.1 31.199609 24 30.099609 L 21 27.099609 L 16 32.099609 C 15.9 33.099609 15.1 34 14 34 C 12.9 34 12 33.1 12 32 C 12 30.9 12.800391 30.1 13.900391 30 L 19 24.900391 C 19.1 23.900391 19.9 23 21 23 C 22.1 23 22.9 23.800391 23 24.900391 L 26 27.900391 L 32 21.900391 C 32.1 20.900391 32.9 20 34 20 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiative);
export default __webpack_public_path__ + "static/media/initiative.d355bd29a954176e497ef1ad2db50a9d.svg";
export { ForwardRef as ReactComponent };